import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormHelperText,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import CustomCheckbox from "../CustomCheckbox";

import { ReactComponent as AlertRed } from "../../icons/alert-red.svg";

import * as Util from "../../services/global.service";

import { postSearch } from "../../actions/admin/workflow";


const ErrorHelper = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <AlertRed />
      <FormHelperText
        error={true}
        sx={{ ml: 1 }}
      >
        {t("label.pleaseFillOutThisField")}
      </FormHelperText>
    </Box>
  )
}

const WorkflowDialog = (props) => {
  const { addData, editData, workflowTemplateData, open, workflowType } = props
  const { t } = useTranslation();
  const language = localStorage.getItem("lang");
  const dispatch = useDispatch();

  const [seq, setSeq] = React.useState("1")
  const [action, setAction] = React.useState("")
  const [actionDropdown, setActionDropdown] = React.useState([])
  const [field, setField] = React.useState("")
  const [fieldDropdown, setFieldDropdown] = React.useState([])
  const [value, setValue] = React.useState("")
  const [valueObject, setValueObject] = React.useState({})
  const [showValue, setShowValue] = React.useState({})
  const [valueSelectedData, setValueSelectedData] = React.useState()
  const [valueDropdown, setValueDropdown] = React.useState([])
  const [isValueDropdownEnable, setIsValueDropdownEnable] = React.useState(false)
  const [descriptionEN, setDescriptionEN] = React.useState("")
  const [descriptionTH, setDescriptionTH] = React.useState("")
  const [tooltipEN, setTooltipEN] = React.useState("")
  const [tooltipTH, setTooltipTH] = React.useState("")
  const [hideScoreToSelf, setHideScoreToSelf] = React.useState(false)
  const [reject, setReject] = React.useState(false)
  const [editable, setEditable] = React.useState(false)
  const [emailNotice, setEmailNotice] = React.useState(true)
  const [fieldValid, setFieldValid] = React.useState({
    seq: true,
    action: true,
    field: true,
    value: true,
    descriptionEN: true,
    descriptionTH: true,
  })
  const [touchSubmit, setTouchSubmit] = React.useState(false)
  const [isFirstSeq, setIsFirstSeq] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const resetForm = () => {
    setSeq("")
    setIsFirstSeq(false)
    setAction("")
    setField("")
    setEditable(false)
    setEmailNotice(true)
    setDescriptionEN("")
    setDescriptionTH("")
    setTooltipEN("")
    setTooltipTH("")
    setHideScoreToSelf(false)
    setReject(false)
  }

  const handleClose = () => {
    setTouchSubmit(false)
    props.onClose(false)
  }

  const validateForm = (fields) => {
    let isValid = false
    let data = {}
    let validateFieldsBase = (fields.seq && fields.action && fields.field && fields.value && fields.descriptionEN && fields.descriptionTH)
    let validateRules = workflowType === "evaluate" || workflowType === "probation" ? validateFieldsBase && (fields.tooltipEN && fields.tooltipTH) : validateFieldsBase
    if (validateRules) {
      data = {
        id: editData?.id,
        stepAssignId: editData?.stepAssignId,
        step: seq,
        action,
        field,
        value: valueSelectedData || null,
        descriptionEN,
        descriptionTH,
        tooltipEN,
        tooltipTH,
        editable,
        emailNotice,
        hideScoreToSelf,
        reject,
        listType: editData?.listType,
        stepType: editData?.stepType
      }
      isValid = true
    }
    return { data, isValid }
  }

  const validateFields = () => {
    let fieldsValid = {
      seq: true,
      action: true,
      field: true,
      value: true,
      descriptionEN: true,
      descriptionTH: true,
      tooltipEN: true,
      tooltipTH: true
    }
    if (!seq || seq === "") {
      fieldsValid = {
        ...fieldsValid,
        seq: false
      }
    }
    if (!action || action === "") {
      fieldsValid = {
        ...fieldsValid,
        action: false
      }
    }
    if (!field || field === "") {
      fieldsValid = {
        ...fieldsValid,
        field: false
      }
    } else if (isValueDropdownEnable) {
      if (!value || value === "") {
        fieldsValid = {
          ...fieldsValid,
          value: false
        }
      }
    }
    if (!descriptionEN || descriptionEN === "") {
      fieldsValid = {
        ...fieldsValid,
        descriptionEN: false
      }
    }
    if (!descriptionTH || descriptionTH === "") {
      fieldsValid = {
        ...fieldsValid,
        descriptionTH: false
      }
    }
    // additional for evaluation
    if (workflowType === "evaluate" || workflowType === "probation") {
      if (!tooltipEN || tooltipEN === "") {
        fieldsValid = {
          ...fieldsValid,
          tooltipEN: false
        }
      }
      if (!tooltipTH || tooltipTH === "") {
        fieldsValid = {
          ...fieldsValid,
          tooltipTH: false
        }
      }
    }
    setFieldValid(fieldsValid)
    let { data, isValid } = validateForm(fieldsValid)
    if (isValid) {
      props.doSubmit(data)
    }
    setIsSubmitting(false)
  }

  const handleValueList = () => {
    setIsValueDropdownEnable(false)
    let getField = [...fieldDropdown].filter(item => item.code === field)
    if (getField.length > 0) {
      getField = getField[0]
      if (getField?.specify) {
        setIsValueDropdownEnable(true)
        let getTable = getField.id.split(":")
        dispatch(postSearch(getTable[0], "")).then(resp => {
          let respField = ""
          let formatData = []
          if (getTable[0] === "employee") {
            respField = "employees"
            formatData = resp[respField].map(item => {
              return {
                name: `${item.first_name} ${item.last_name} (${item.code})`,
                value: item.id,
                code: item.code,
                oName: `${item.first_name} ${item.last_name}`,
              }
            })
          } else if (getTable[0] === "position") {
            respField = "position"
            formatData = resp[respField].map(item => {
              return {
                name: `${item.name} (${item.code})`,
                value: item.id,
                code: item.code,
                oName: `${item.name}`,
              }
            })
          }
          setValueDropdown(formatData)
        })
      }
    }
  }

  const changeFieldValue = (e) => {
    setField(e)
    setValue("")
    setShowValue(undefined)
  };


  const changeValueValue = (e) => {
    setShowValue(e)
    setValue(Util.formatData(e?.value, ""));
  }

  const changeActionValue = (e) => {
    setAction(e);
  }

  const changeTooltipEnValue = (e) => {
    setTooltipEN(e);
  }

  const changeTooltipThValue = (e) => {
    setTooltipTH(e);
  }

  const changeDescEnValue = (e) => {
    setDescriptionEN(e);
  }

  const changeDescThValue = (e) => {
    setDescriptionTH(e);
  }

  const handleSubmit = () => {
    setIsSubmitting(true)
    setTouchSubmit(true, validateFields())
  }

  const prepareData = (data) => {
    let actions = data.actions.filter(field => !field.disabled).map(item => {
      return { name: item.label, value: item.code, ...item }
    })
    let fields = data.fields.filter(field => !field.disabled).map(item => {
      return { name: item.label, value: item.code, ...item }
    })
    setActionDropdown(actions)
    setFieldDropdown(fields)
  }

  // useEffect
  useEffect(() => {
    resetForm()
  }, [open])
  useEffect(() => {
    if (workflowTemplateData?.actions && workflowTemplateData?.fields) prepareData(workflowTemplateData)
  }, [workflowTemplateData])
  useEffect(() => {
    if (props.type === "edit") {
      let data = editData
      setSeq(data?.step || "")
      if ((data?.step === 1 || data?.action?.code === "submit")) {
        setIsFirstSeq(true)
      } else {
        setIsFirstSeq(false)
      }
      let filterField = data?.step > 1 && data?.action?.code !== "submit" ? data?.fields?.filter(field => !field?.disabled) : data?.fields
      setAction(data?.action?.code || "")
      setField(filterField?.length > 0 ? filterField[0]?.code : "")
      setValue(filterField?.length > 0 ? filterField[0]?.value?.id : "")
      setValueObject(filterField?.length > 0 ? filterField[0]?.value : {})
      setDescriptionEN(data?.description?.en || "")
      setDescriptionTH(data?.description?.th || "")
      setTooltipEN(data?.tooltip?.en || "")
      setTooltipTH(data?.tooltip?.th || "")
      setEditable(data?.options?.edit || false)
      setHideScoreToSelf(data?.options?.hide_score_self || false)
      setReject(data?.options?.reject || false)
      setEmailNotice(data?.is_send_mail)
    } else {
      let data = addData
      setSeq(data?.countStep + 1)
      setEmailNotice(data?.is_send_mail)
    }
  }, [props.type, props.editData, props.addData])
  useEffect(() => {
    handleValueList()
  }, [field])
  useEffect(() => {
    if (field === 'position' && valueObject?.code) {
      let findValue = valueDropdown.find(item => (item.code === valueObject?.code))
      if (findValue) {
        setValueSelectedData(findValue)
        setShowValue(findValue)
      } else {
        let findValue = valueDropdown.find(item => item.value === value)
        if (findValue) {
          setValueSelectedData(findValue)
          setShowValue(findValue)
        }
      }

    } else if (value && value !== "") {
      let findValue = valueDropdown.find(item => item.value === value)
      if (findValue) {
        setValueSelectedData(findValue)
        setShowValue(findValue)
      }
    } else {
      setValueSelectedData(null)
    }
  }, [field, value, valueObject, valueDropdown])
  // end useEffect

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="lg"
        fullWidth={true}
        PaperProps={{ sx: { p: 3 } }}
        aria-labelledby="create-dialog-title"
        aria-describedby="create-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: "0 0 12px 0" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              p: 0,
              m: 0,
              width: "100%",
            }}
          >
            <Typography fontSize="24px" fontWeight="600" color="#404349">
              {props?.type === "add" ? t("adminWorkflow.dialog.addWorkflow") : t("adminWorkflow.dialog.editWorkflow")}
            </Typography>
            <Typography
              color="#404349"
              style={{ cursor: "pointer" }}
              sx={{ ml: "auto" }}
              onClick={() => handleClose()}
            >
              X
            </Typography>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: "5px 0px!important" }}>
          <DialogContentText
            id="content-dialog-description"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexFlow: "column",
            }}
            component="div"
          >
            <Grid container mt={1.5} columnSpacing={6}>
              <Grid item xs={12} sm={6}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.sequence")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.action")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0} columnSpacing={6}>
              <Grid item xs={12} sm={6}
                sx={{
                  p: 0,
                  ".MuiInputBase-input": {
                    backgroundColor: "#FAFAFA",
                    "-webkit-text-fill-color": "#000 !important",
                    borderRadius: "4px",
                    p: "4px 10px",
                    height: "35px",
                  },
                  fieldset: { borderColor: "#FFFFFF !important" },
                }}
              >
                <TextField
                  id="outlined-basic"
                  value={seq}
                  variant="outlined"
                  disabled
                  fullWidth
                  size="small"
                />
              </Grid>
              {!isFirstSeq && workflowType !== "evaluate" && workflowType !== "probation" ?
                (<Grid item xs={12} sm={6} columnSpacing={6}>
                  <FormControl fullWidth>
                    <Select
                      className="custom-placeholder"
                      displayEmpty
                      error={touchSubmit && !fieldValid?.action}
                      labelId="action"
                      id="action"
                      input={<OutlinedInput size="small" />}
                      value={action}
                      onChange={(e) => changeActionValue(e.target.value)}
                      renderValue={
                        action !== "" ? undefined : () => <Typography fontSize="16px" fontWeight="300" color="#AAAAAA">{t("adminWorkflow.label.selectTheAction")}</Typography>
                      }
                    >
                      {actionDropdown.map((option, idx) => {
                        return <MenuItem key={idx} value={option.value}><Typography fontWeight="400" fontSize='16px' color='#404349' component="span">{option.name}</Typography></MenuItem>
                      })}
                    </Select>
                  </FormControl>
                  {
                    touchSubmit && !fieldValid?.action && <ErrorHelper />
                  }
                </Grid>)
                : (
                  <Grid item xs={12} sm={6}
                    sx={{
                      p: 0,
                      ".MuiInputBase-input": {
                        backgroundColor: "#FAFAFA",
                        "-webkit-text-fill-color": "#000 !important",
                        borderRadius: "4px",
                        p: "4px 10px",
                        height: "35px",
                        textTransform: action !== "signoff" ? "capitalize" : "none"
                      },
                      fieldset: { borderColor: "#FFFFFF !important" },
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      value={action === "signoff" ? language === "en-US" ? "Sign off" : "ลงนาม" : action}
                      variant="outlined"
                      disabled
                      fullWidth
                      size="small"
                    />
                  </Grid>
                )
              }
            </Grid>
            <Grid container mt={1.5} columnSpacing={6}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.field")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0} columnSpacing={6}>
              {!isFirstSeq || (workflowType === "probation" && action !== "submit") ?
                (<Grid item xs={12}>
                  <FormControl fullWidth>
                    <Select
                      className="custom-placeholder"
                      displayEmpty
                      error={touchSubmit && !fieldValid?.field}
                      labelId="field"
                      id="field"
                      input={<OutlinedInput size="small" />}
                      value={field}
                      onChange={(e) => changeFieldValue(e.target.value)}
                      renderValue={
                        field !== "" ? undefined : () => <Typography fontSize="16px" fontWeight="300" color="#AAAAAA">{t("adminWorkflow.label.selectTheField")}</Typography>
                      }
                    >
                      {fieldDropdown.map((option, idx) => {
                        return <MenuItem key={idx} value={option.value}><Typography fontWeight="400" fontSize='16px' color='#404349' component="span">{option.name}</Typography></MenuItem>
                      })}
                    </Select>
                  </FormControl>
                  {
                    touchSubmit && !fieldValid?.field && <ErrorHelper />
                  }
                </Grid>)
                : (
                  <Grid item xs={12}
                    sx={{
                      p: 0,
                      ".MuiInputBase-input": {
                        backgroundColor: "#FAFAFA",
                        "-webkit-text-fill-color": "#000 !important",
                        borderRadius: "4px",
                        p: "4px 10px",
                        height: "35px",
                        textTransform: "capitalize"
                      },
                      fieldset: { borderColor: "#FFFFFF !important" },
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      value={field}
                      variant="outlined"
                      disabled
                      fullWidth
                      size="small"
                    />
                  </Grid>
                )
              }
            </Grid>
            <Grid container mt={1.5} columnSpacing={6}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color={isValueDropdownEnable ? "#404349" : "#BABABA"}>
                  {t("adminWorkflow.dialog.value")} <span style={{ color: isValueDropdownEnable ? "#CC6058" : "#BABABA", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0} columnSpacing={6}>
              {isValueDropdownEnable ?
                (
                  <Grid item xs={12} sx={{ "& .Mui-disabled": { background: "#F3F3F3" } }}>
                    <FormControl fullWidth>
                      <Autocomplete
                        id="checkboxes-tags-demo"
                        size="small"
                        fullWidth
                        options={valueDropdown}
                        defaultValue=""
                        value={showValue}
                        onChange={(event, newValue) => {
                          changeValueValue(newValue)
                        }}
                        disableClearable
                        getOptionLabel={(option) => Util.formatData(option?.name, "")}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={`Select`}
                            InputLabelProps={{
                              ...params.inputProps,
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    </FormControl>
                    {
                      isValueDropdownEnable && (touchSubmit && !fieldValid?.value) && <ErrorHelper />
                    }
                  </Grid>)
                : (
                  <Grid item xs={12}
                    sx={{
                      p: 0,
                      ".MuiInputBase-input": {
                        backgroundColor: "#FAFAFA",
                        "-webkit-text-fill-color": "#000 !important",
                        borderRadius: "4px",
                        p: "4px 10px",
                        height: "35px",
                      },
                      fieldset: { borderColor: "#FFFFFF !important" },
                    }}
                  >
                    <TextField
                      id="outlined-basic"
                      value={value}
                      variant="outlined"
                      disabled
                      fullWidth
                      size="small"
                    />
                  </Grid>
                )
              }
            </Grid>
            <Grid container mt={1.5} columnSpacing={6}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.descriptionEN")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0} columnSpacing={6}>
              <Grid item xs={12}>
                <TextField
                  id="description-en"
                  value={descriptionEN}
                  multiline
                  error={touchSubmit && !fieldValid?.descriptionEN}
                  onChange={(e) => changeDescEnValue(e.target.value)}
                  variant="outlined"
                  placeholder={t("adminWorkflow.label.fillTheDescriptionEN")}
                  fullWidth
                  size="small"
                />
                {
                  (touchSubmit && !fieldValid?.descriptionEN) && <ErrorHelper />
                }
              </Grid>
            </Grid>
            <Grid container mt={1.5} columnSpacing={6}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.descriptionTH")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} columnSpacing={6}>
              <Grid item xs={12}>
                <TextField
                  id="description-th"
                  value={descriptionTH}
                  multiline
                  error={touchSubmit && !fieldValid?.descriptionTH}
                  onChange={(e) => changeDescThValue(e.target.value)}
                  variant="outlined"
                  placeholder={t("adminWorkflow.label.fillTheDescriptionTH")}
                  fullWidth
                  size="small"
                />
                {
                  (touchSubmit && !fieldValid?.descriptionTH) && <ErrorHelper />
                }
              </Grid>
            </Grid>
            {workflowType && (workflowType === "evaluate" || workflowType === "probation") &&
              <>
                <Grid container mt={1.5} columnSpacing={6}>
                  <Grid item xs={12}>
                    <Typography fontSize="18px" fontWeight="500" color="#404349">
                      {t("adminWorkflow.dialog.tooltipEN")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mt={0.5} mb={0} columnSpacing={6}>
                  <Grid item xs={12}>
                    <TextField
                      id="tooltip-en"
                      value={tooltipEN}
                      error={touchSubmit && !fieldValid?.tooltipEN}
                      onChange={(e) => changeTooltipEnValue(e.target.value)}
                      variant="outlined"
                      placeholder={t("adminWorkflow.label.fillTheTooltipEN")}
                      fullWidth
                      size="small"
                    />
                    {
                      (touchSubmit && !fieldValid?.tooltipEN) && <ErrorHelper />
                    }
                  </Grid>
                </Grid>
                <Grid container mt={1.5} columnSpacing={6}>
                  <Grid item xs={12}>
                    <Typography fontSize="18px" fontWeight="500" color="#404349">
                      {t("adminWorkflow.dialog.tooltipTH")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container mt={0.5} mb={2} columnSpacing={6}>
                  <Grid item xs={12}>
                    <TextField
                      id="tooltip-th"
                      value={tooltipTH}
                      error={touchSubmit && !fieldValid?.tooltipTH}
                      onChange={(e) => changeTooltipThValue(e.target.value)}
                      variant="outlined"
                      placeholder={t("adminWorkflow.label.fillTheTooltipTH")}
                      fullWidth
                      size="small"
                    />
                    {
                      (touchSubmit && !fieldValid?.tooltipTH) && <ErrorHelper />
                    }
                  </Grid>
                </Grid>
              </>
            }
            {(!isFirstSeq || workflowType === "probation") &&
              <>
                {(workflowType === "evaluate" || (workflowType === "probation" && action !== "submit")) &&
                  <>
                    <Grid container mt={1.5}>
                      <Grid item xs={12}>
                        <Grid container>
                          <Grid item xs="auto" display="flex" alignItems="flex-start" mr={1.5}>
                            <CustomCheckbox sx={{ p: "0!important" }} checked={hideScoreToSelf} onChange={() => setHideScoreToSelf(!hideScoreToSelf)} />
                          </Grid>
                          <Grid item xs="auto">
                            <Grid container item display="flex" flexDirection="column" alignItems="flex-start" sx={{ "& .MuiTypography-root": { lineHeight: 1.25 } }}>
                              <Typography fontSize="18px" fontWeight="500" color="#404349">
                                {t("adminWorkflow.dialog.hideScoreToSelf")}
                              </Typography>
                              <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                                {t("adminWorkflow.dialog.hideScoreToSelfDesc")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {action == "approve" &&
                      <>
                        <Grid container mt={1.5}>
                          <Grid item xs={12}>
                            <Grid container>
                              <Grid item xs="auto" display="flex" alignItems="flex-start" mr={1.5}>
                                <CustomCheckbox sx={{ p: "0!important" }} checked={reject} onChange={() => setReject(!reject)} />
                              </Grid>
                              <Grid item xs="auto">
                                <Grid container item display="flex" flexDirection="column" alignItems="flex-start" sx={{ "& .MuiTypography-root": { lineHeight: 1.25 } }}>
                                  <Typography fontSize="18px" fontWeight="500" color="#404349">
                                    {t("adminWorkflow.dialog.enableReject")}
                                  </Typography>
                                  <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                                    {t("adminWorkflow.dialog.enableRejectDesc")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid container mt={1.5}>
                          <Grid item xs={12}>
                            <Grid container>
                              <Grid item xs="auto" display="flex" alignItems="flex-start" mr={1.5}>
                                <CustomCheckbox sx={{ p: "0!important" }} checked={editable} onChange={() => setEditable(!editable)} />
                              </Grid>
                              <Grid item xs="auto">
                                <Grid container item display="flex" flexDirection="column" alignItems="flex-start" sx={{ "& .MuiTypography-root": { lineHeight: 1.25 } }}>
                                  <Typography fontSize="18px" fontWeight="500" color="#404349">
                                    {t("adminWorkflow.dialog.editable")}
                                  </Typography>
                                  <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                                    {t("adminWorkflow.dialog.editableDesc")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    }
                  </>
                }
                {(workflowType === "goal") &&
                  <Grid container mt={1.5}>
                    <Grid item xs={12}>
                      <Grid container>
                        <Grid item xs="auto" display="flex" alignItems="flex-start" mr={1.5}>
                          <CustomCheckbox sx={{ p: "0!important" }} checked={editable} onChange={() => setEditable(!editable)} />
                        </Grid>
                        <Grid item xs="auto">
                          <Grid container item display="flex" flexDirection="column" alignItems="flex-start" sx={{ "& .MuiTypography-root": { lineHeight: 1.25 } }}>
                            <Typography fontSize="18px" fontWeight="500" color="#404349">
                              {t("adminWorkflow.dialog.editable")}
                            </Typography>
                            <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                              {t("adminWorkflow.dialog.editableDesc")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                }
              </>
            }
            <Grid container mt={1.5}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs="auto" display="flex" alignItems="flex-start" mr={1.5}>
                    <CustomCheckbox sx={{ p: "0!important" }} checked={emailNotice} onChange={() => setEmailNotice(!emailNotice)} />
                  </Grid>
                  <Grid item xs="auto">
                    <Grid container item display="flex" flexDirection="column" alignItems="flex-start" sx={{ "& .MuiTypography-root": { lineHeight: 1.25 } }}>
                      <Typography fontSize="18px" fontWeight="500" color="#404349">
                        {t("adminWorkflow.dialog.enableEmailNotification")}
                      </Typography>
                      <Typography fontSize="14px" fontWeight="400" color="#AAAAAA">
                        {t("adminWorkflow.dialog.enableEmailNotificationDesc")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0, mt: 2 }}>
          <Button onClick={handleSubmit} size="large" variant="contained" sx={{ minWidth: '144px', width: "fit-content" }} style={{ textTransform: 'none' }} disabled={isSubmitting}>{props.type === "add" ? t(`label.add`) : t(`label.save`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default WorkflowDialog;
